import { AdornedInput, Box, FormField } from '@zillow/constellation-10';
import { IconChevronDownFilled } from '@zillow/constellation-icons';
import { Bone } from '@zg-rentals/satellite-components';
import SkeletonContainer from '../SkeletonContainer';
import { forwardRef } from 'react';
import { formFieldStyles } from '.';

export const PropertyDropdownSkeleton = () => {
  return (
    <FormField
      css={formFieldStyles}
      control={
        <AdornedInput
          disabled
          input={
            <AdornedInput.Input
              placeholder="Enter a property"
              css={{
                backgroundColor: 'bg.action.neutral.default',
                paddingBlock: 'tightest',
              }}
            />
          }
          endAdornment={
            <AdornedInput.Adornment
              css={{
                backgroundColor: 'bg.action.neutral.default',
              }}
            >
              <AdornedInput.Icon>
                <IconChevronDownFilled />
              </AdornedInput.Icon>
            </AdornedInput.Adornment>
          }
        />
      }
    />
  );
};

export const Skeleton = forwardRef<HTMLDivElement>((_, ref) => (
  <SkeletonContainer ref={ref}>
    <Box
      css={{
        minWidth: '300px',
        paddingBlock: 'default',
        smDown: {
          minWidth: '165px',
        },
      }}
    >
      <Bone type="line" />
    </Box>
  </SkeletonContainer>
));

export const SkeletonListItem = forwardRef<HTMLDivElement>((_, ref) => (
  <SkeletonContainer ref={ref}>
    <Box css={{ margin: 'default' }}>
      <Bone css={{ width: '66.67%' }} />
      <Bone css={{ width: '83.33%', marginTop: 'default' }} />
    </Box>
  </SkeletonContainer>
));
